module.exports = __webpack_public_path__ + "static/media/menu-bkg-tablet.b9a10edb.jpg";